import { render, staticRenderFns } from "./RendersPreviewWindow.vue?vue&type=template&id=5cb8f952&scoped=true&"
import script from "./RendersPreviewWindow.vue?vue&type=script&lang=ts&"
export * from "./RendersPreviewWindow.vue?vue&type=script&lang=ts&"
import style0 from "./RendersPreviewWindow.vue?vue&type=style&index=0&id=5cb8f952&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb8f952",
  null
  
)

export default component.exports